import {TbMessage2Question} from "react-icons/tb";
import {GoInfo} from "react-icons/go";
import {Button, Form} from "react-bootstrap";
import {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import AppContext from "../../AppContext";

export default function ManualQuestion({ quiz, setQuiz, goNext }) {
    const app = useContext(AppContext)
    const { t, i18n } = useTranslation();
    const [manualAnswer, setManualAnswer] = useState('');

    useEffect(() => {
        setManualAnswer('')
    }, [quiz.questionIdx])

    const noImage = quiz.question.image_uri === null || quiz.question.image_uri === ''

    const isCorrect = () => {
        var correct = 0;
        quiz.question.correct.forEach((answer, idx) => {
            if(answer.toLowerCase().trim() == manualAnswer.toLowerCase().trim())
                correct++;
        });

        return correct > 0;
    }
    const submitAnswer = () => {
        let q = {...quiz}
        const correct = isCorrect()
        if(correct)
            app.playSfxCorrect()
        else
            app.playSfxWrong()

        q.lastResult = correct ? 1 : 0
        q.results[quiz.questionIdx] = correct ? 1 : 0
        if(!correct) {
            q.perfect = false
            q.questions.push(q.questions[q.questionIdx])
        }
        setQuiz({...q})
    }

    return <div className={"quiz-question " + (noImage ? 'no-image' : '')}>
        <div className="q-image">
            {!noImage && <img src={quiz.question.image_uri} alt="" />}
            {noImage && <TbMessage2Question className="placeholder-image" />}
        </div>
        <div className="q-details">
            <ul className="q-answers">
                <li>
                    <Form.Group className="mb-3 form-floating" controlId="manual_answer">
                        <Form.Control type="text" placeholder={t('form.yourAnswer')} disabled={quiz.lastResult !== -1} name="manual_answer" value={manualAnswer} onChange={(e) => setManualAnswer(e.target.value)} />
                        <Form.Label>{t('form.yourAnswer')}</Form.Label>
                    </Form.Group>
                </li>
                {quiz.lastResult === -1 &&
                    <li>
                        <p className="small text-muted"><GoInfo style={{fontSize: 16}} /> {t('form.yourAnswerNote')}</p>
                        <Button variant="primary" onClick={submitAnswer}>{t('button.submitAnswer')}</Button>
                    </li>}
                {quiz.lastResult === 1 &&
                    <li>
                        <h4 className="text-success fw-bold">{t('good')}</h4>
                        <p className="small text-muted" dangerouslySetInnerHTML={{__html: quiz.question.explanation}} />
                        <Button variant="primary" onClick={goNext}>{t('button.next')}</Button>
                    </li>}
                {quiz.lastResult === 0 &&
                    <li>
                        <h4 className="text-danger fw-bold">{t('wrong')}</h4>
                        <p className="small text-muted" dangerouslySetInnerHTML={{__html: quiz.question.explanation}} />
                        <Button variant="primary" onClick={goNext}>{t('button.next')}</Button>
                    </li>}
            </ul>
        </div>
    </div>
}